/**
 * mk-auth host for the OAuth flow (RGI-3275).
 *
 * One addax build serves app.madkudu.com / app.wisekudu.com and the
 * *.hginsights.* proxies, and the mk-auth session cookie lives on the parent
 * domain of the auth host. So the auth host follows the page host: hginsights
 * pages use the hginsights mk-auth proxies, every other host keeps the
 * build-time ACCESS_API_URL (same split as getBongoUrl, same mapping as
 * Studio's oauth.ts).
 */
export function getAccessApiUrl(
  hostname: string = window.location.hostname
): string {
  if (hostname.endsWith('.hginsights.com')) {
    return 'https://access-api.hginsights.com';
  }
  if (hostname.endsWith('.hginsights.info')) {
    return 'https://access-api-staging.hginsights.info';
  }
  return ACCESS_API_URL;
}
